module.exports = __webpack_public_path__ + "img/almode-avatar.05a439ac.png";